import {api} from "./api";

export const CarCategoryFilter = (typeInfo) => {
    return {
        type_id: typeInfo.type_id,
        type: typeInfo,
        search: '',
        init() {
            this.$watch('search', (value, old) => {
                api.get(
                    `custom/categories/search&search=${value}&typeId=${this.type_id}`
                ).then(async (response) => {
                    const text = await response.text();
                    const html = document.getElementById('categories')
                    html.innerHTML = text;
                })
            })
        }
    }
}